import { createBrowserRouter } from "react-router-dom";

import { NotFoundState } from "./components/states";
import { PublicHome } from "./pages/public-home";
import { UnavailablePage } from "./pages/unavailable-page";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicHome />,
  },
  {
    path: "/auth/*",
    element: (
      <UnavailablePage
        eyebrow="Secure sign-in"
        title="Account access is not active yet"
        description="Passkey-first authentication arrives in Phase 2. This route is intentionally unavailable until the server-enforced security boundary exists."
      />
    ),
  },
  {
    path: "/app/*",
    element: (
      <UnavailablePage
        eyebrow="Owner application"
        title="Your private file is not active yet"
        description="The application shell is ready, but no owner data can be created or viewed before authentication and the canonical data model are complete."
      />
    ),
  },
  {
    path: "/invite/*",
    element: (
      <UnavailablePage
        eyebrow="Trusted contact invitation"
        title="Invitations are not active yet"
        description="Invitation links will remain unavailable until identity verification and disclosure-safe invitation handling are implemented."
      />
    ),
  },
  {
    path: "/family/*",
    element: (
      <UnavailablePage
        eyebrow="Family access"
        title="Family access is not active yet"
        description="No Start Here File information is available here until explicit viewer grants and server-side field filtering exist."
      />
    ),
  },
  {
    path: "/advisor/*",
    element: (
      <UnavailablePage
        eyebrow="Lawyer or advisor access"
        title="Advisor access is not active yet"
        description="This route is intentionally closed until scoped grants and advisor-specific read models are implemented."
      />
    ),
  },
  {
    path: "*",
    element: <NotFoundState />,
  },
]);
